import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索你最感兴趣的吃瓜方向</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-5 py-3 rounded-xl border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200/60 hover:bg-primary-100 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/60 hover:border-foreground-300'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 bg-primary-500 rounded-full flex-shrink-0"></span>
              )}
              <span className={`text-sm font-medium ${
                topic.hot ? 'text-primary-700' : 'text-foreground-700'
              }`}>
                {topic.name}
              </span>
              <span className={`text-xs ${
                topic.hot ? 'text-primary-400' : 'text-foreground-400'
              }`}>
                {topic.count.toLocaleString()}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}